import "./App.css";
// Header is now integrated into HeroSection
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Showcase from "./components/Showcase/index.js";
import InfoHead from "./components/InfoHead/index.js";
import CreateBiodata from "./components/CreateBiodata/index.js";
import { ToastContainer } from "react-toast";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import React from "react";
import Footer from "./components/Footer/index.jsx";
import Download from "./components/Download/index.jsx";
import { lazy, Suspense, useState } from "react";

// New Homepage Components
import HeroSection from "./components/HeroSection/index.jsx";
import TemplateGallery from "./components/TemplateGallery/index.jsx";
import StepsSection from "./components/StepsSection/index.jsx";
import FeaturesSection from "./components/FeaturesSection/index.jsx";
import TestimonialsSection from "./components/TestimonialsSection/index.jsx";
import FinalCTA from "./components/FinalCTA/index.jsx";
import FAQs from "./components/TextComponents/FAQs.jsx";
import FormSection from "./components/FormSection/index.jsx";
import FloatingActionButton from "./components/FloatingActionButton/index.jsx";

const PrivacyPolicy = lazy(() =>
  import("./components/privacyPolicy/provacyPolicy.jsx")
);
const Terms = lazy(() =>
  import("./components/privacyPolicy/termsAndCondiions.jsx")
);
const RefundPolicy = lazy(() =>
  import("./components/privacyPolicy/refund.jsx")
);
const DeliveryPolicy = lazy(() =>
  import("./components/privacyPolicy/shipping.jsx")
);
const ContactUs = lazy(() =>
  import("./components/privacyPolicy/contact-us.jsx")
);

const theme = createTheme({
  palette: {
    primary: { main: "#00051F" },
    secondary: { main: "#000000" },
    gray: { main: "#808080" },
    green: { main: "#50C878" },
    damGray: { main: "#e8eaef" },
    danger: { main: "#8B0000" },
    pink: { main: "#FF81A0" },
    white: { main: "white" },
  },
});

const RealApp = ({ onTemplateSelectChange }) => {
  return (
    <main role="main">
      {/* New Modern Homepage Structure */}
      <HeroSection />
      
      <section id="templates" aria-label="Template Gallery">
        <TemplateGallery />
      </section>
      
      {/* Main Create Biodata Section - After template gallery */}
      <section id="create-biodata" aria-label="Create Your Biodata">
        <FormSection onTemplateSelectChange={onTemplateSelectChange} />
      </section>
      
      <StepsSection />
      
      <section id="why-choose-us" aria-label="Why Choose Us">
        <FeaturesSection />
      </section>
      
      <TestimonialsSection />
      
      <FinalCTA />
      
      <section id="faq-section" aria-label="Frequently Asked Questions">
        <FAQs />
      </section>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://biodatamaker.co.in/"
          }, {
            "@type": "ListItem",
            "position": 2,
            "name": "Create Biodata",
            "item": "https://biodatamaker.co.in/create/english"
          }]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "Biodata Maker",
          "description": "Create your biodata online with our professional biodata maker tool",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "What is a biodata?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "A biodata is a detailed document that contains personal, educational, and other relevant information about an individual. It helps others understand more about the person's background and details."
            }
          }, {
            "@type": "Question",
            "name": "How does the biodata maker work?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our biodata maker provides professional templates and tools to create, edit, and download your biodata with ease. Simply choose a template, fill in your details, and generate your biodata."
            }
          }, {
            "@type": "Question",
            "name": "What languages are supported?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our biodata maker supports multiple languages including English, Hindi, and Marathi, making it accessible to a wider audience."
            }
          }, {
            "@type": "Question",
            "name": "Can I edit my biodata after creating it?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, you can edit your biodata at any time. Simply log in to your account and make the necessary changes to your information."
            }
          }]
        })}
      </script>
    </main>
  );
};

export default () => {
  const [isTemplateSelecting, setIsTemplateSelecting] = useState(false);

  const handleTemplateSelectChange = (selecting) => {
    setIsTemplateSelecting(selecting);
  };

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <div className="flex w-full flex-col h-screen overflow-x-hidden" role="application">
          <ToastContainer delay={3000} />
          {/* Floating Action Button */}
          <FloatingActionButton hideWhenTemplateSelecting={isTemplateSelecting} />
          {/* Header is now integrated into HeroSection */}
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route exact path="/terms-of-service" component={Terms} />
              <Route exact path="/refund" component={Download} />
              <Route exact path="/download/:order_id" component={Download} />
              <Route exact path="/refund-policy" component={RefundPolicy} />
              <Route exact path="/contact-us" component={ContactUs} />
              <Route exact path="/shipping-policy" component={DeliveryPolicy} />
              <Route exact path="/" render={() => <RealApp onTemplateSelectChange={handleTemplateSelectChange} />} />
              <Route exact path="/create/marathi" render={() => <RealApp onTemplateSelectChange={handleTemplateSelectChange} />} />
              <Route exact path="/create/english" render={() => <RealApp onTemplateSelectChange={handleTemplateSelectChange} />} />
              <Route exact path="/create/hindi" render={() => <RealApp onTemplateSelectChange={handleTemplateSelectChange} />} />
            </Switch>
          </Suspense>
          <Footer />
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
};
